import * as React from 'react'

import type { UseOrgGatewayRpcReturn } from '../hooks/useOrgGatewayRpc'

/**
 * Context that exposes the live `useOrgGatewayRpc` result to every admin page
 * rendered inside `AdminShell`. Pages use `useAdminGateway()` to obtain the
 * `call` function and the current connection `status`.
 *
 * Always null outside of AdminShell — `useAdminGateway` will throw so that
 * mis-use is caught at development time.
 */
export const AdminGatewayContext = React.createContext<UseOrgGatewayRpcReturn | null>(null)

/**
 * Hook for admin pages to access the gateway RPC client.
 * Must be called from inside a tree wrapped by `AdminShell`.
 */
export function useAdminGateway(): UseOrgGatewayRpcReturn {
  const ctx = React.useContext(AdminGatewayContext)
  if (!ctx) {
    throw new Error('useAdminGateway must be used inside AdminShell')
  }
  return ctx
}
